import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import de from "./locales/de.json";
import en from "./locales/en.json";
import tr from "./locales/tr.json";
import fr from "./locales/fr.json";
import deAdmin from "./locales/admin/de.json";
import enAdmin from "./locales/admin/en.json";
import trAdmin from "./locales/admin/tr.json";
import frAdmin from "./locales/admin/fr.json";

export const SUPPORTED_LANGUAGES = [
  { code: "de", label: "Deutsch", short: "DE" },
  { code: "en", label: "English", short: "EN" },
  { code: "tr", label: "Türkçe", short: "TR" },
  { code: "fr", label: "Français", short: "FR" },
];

const LOCALE_MAP = { de: "de-DE", en: "en-US", tr: "tr-TR", fr: "fr-FR" };

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: { translation: { ...de, ...deAdmin } },
      en: { translation: { ...en, ...enAdmin } },
      tr: { translation: { ...tr, ...trAdmin } },
      fr: { translation: { ...fr, ...frAdmin } },
    },
    fallbackLng: "de",
    supportedLngs: ["de", "en", "tr", "fr"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage"],
      caches: ["localStorage"],
      lookupLocalStorage: "lang",
    },
  });

export function formatDate(value, opts = {}) {
  if (!value) return "";
  const locale = LOCALE_MAP[i18n.language] || "de-DE";
  try {
    return new Date(value).toLocaleDateString(locale, opts);
  } catch {
    return "";
  }
}

export function formatDateTime(value) {
  if (!value) return "";
  const locale = LOCALE_MAP[i18n.language] || "de-DE";
  try {
    return new Date(value).toLocaleString(locale);
  } catch {
    return "";
  }
}

export default i18n;
